<template>
    <div>
        <loading v-if="loadingRender"></loading>
        <div class="d-flex justify-content-center">
            <div class="card p-3 m-3 w-100" id="Date">

                <div class="row">

                    <!-- <div class="form-group text-right mt-2 mr-3 col-12 col-md-4">
                        <small>توکن</small>
                        <input type="email" class="form-control" v-model="token">
                    </div> -->
                    <div class="col-md-2 col-12 mt-2 text-right">
                        <small>تاریخ</small>
                        <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="date">
                        </date-picker>
                        <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
                    </div>

                    <div class="col-md-2 col-12 mt-3">
                        <input type="button" name="" value="جستجو" class="btn btn-success mt-2 w-100"
                            @click="search()" />
                    </div>

                    <div class="col-md-2 col-12 mt-3">
                        <export-excel :data="exceltable">
                            <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel"
                                @click="exelReport">
                                دانلود فایل اکسل
                            </i>
                        </export-excel>
                    </div>
                </div>

            </div>
        </div>
        <div class="card p-3 m-3 d-flex justify-content-center" id="Date2">

            <!-- <div class="d-flex mb-3 text-center justify-content-between"
                v-if="date != '' & response.notInsertEnteghalDetails.length > 0">
                <div class="card p-2 col-3">
                    <div class="card-body">
                        <h5>تعداد تراکنش : {{ response.transctionCount }}</h5>
                    </div>
                </div>
                <div class="card p-2 col-3">
                    <div class="card-body">
                        <h5> جمع مبلغ : {{ $Comma3ragham(response.transctionSum) }}</h5>
                    </div>
                </div>
                <div class="card p-2 col-3">
                    <div class="card-body">
                        <h5> جمع مبلغ پس از کسر کارمزد : {{ $Comma3ragham(response.transctionSumWithKarmozd) }}</h5>
                    </div>
                </div>

            </div> -->

            <vue-bootstrap4-table :rows="response" :columns="columns" :config="config" :classes="classes"
                :actions="actions" @on-download="Download">
                <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                </template>
                <template slot="payment_amount" slot-scope="props">
                    {{ $Comma3ragham(props.row.payment_amount) }}
                </template>
                <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                </template>
            </vue-bootstrap4-table>


            <!-- <button v-if="date != '' & response.notInsertEnteghalDetails.length > 0" 
                class="btn btn-primary col-12 col-md-2 mb-3">ثبت
                واریزی های {{ date }} </button> -->

        </div>

    </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";

export default {
    beforeMount() {
        let token = this.$cookies.get('payStartToken')
        if (token != null)
            this.token = token
        this.response.notInsertEnteghalDetails = []
    },
    data() {
        return {
            token: '',
            date: '',
            exceltable: [],
            Iban: '',
            response: [],
            columns: [{
                label: "id",
                name: "id",
                visibility: false,
            },

            {
                label: "شماره سفارش",
                name: "order_id",
            },
            {
                label: "تاریخ",
                name: "created_at",
            },
            {
                label: "شماره مرجع بانکی",
                name: "ref_id",
            },
            {
                label: "مبلغ تراکنش",
                name: "payment_amount",
            },
            {
                label: "شماره کارت",
                name: "card_number",
            },
            {
                label: "موبایل پرداخت کننده",
                name: "payer_phone",
            },

            ],
            actions: [{
                btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
                event_name: "on-download",
                class: "btn  mx-2 btn-outline-success rounded btnEXL ",
                event_payload: { msg: "my custom msg", },
            }],
            config: {
                pagination: true,
                pagination_info: false,
                per_page_options: [10, 20, 30, 50, 100],
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                card_title: "",
                card_mode: false,
                global_search: {
                    placeholder: " جستجو",
                    visibility: true,
                    case_sensitive: false,
                    showClearButton: true,
                    searchOnPressEnter: false,
                },
            },
            classes: {
                table: "table-bordered table-striped table-sm ",
            },
            loadingRender: false,
        }
    },
    components: {
        VueBootstrap4Table, loading
    },
    methods: {

        sabt() {
            let axios = {
                ArryfildValue: {
                    date: this.date,
                    token: this.token,
                },
                Method: "Post",
                Action: "TransactionService/InsertToEnteghalPayStar",
            }
            this.loadingRender = true;
            this.$PostData(axios).then((data) => {
                console.log(data)
                if (data.isSuccess == false) {
                    this.$mySweetDefaultTost("", data.message, "error", 2000);
                } else {
                    this.$mySweetDefaultTost("", data.message, "success", 2000);
                }
                this.loadingRender = false;

            }).catch(err => {
                this.$mySweetDefaultTost("", "خطا در سرور", "error", 2000);
                this.loadingRender = false;
            }).finally(() => {
                this.response = {}
                this.response.NotInsertEnteghalDetails = []
            })

        },

        search() {
            let axios = {
                ArryfildValue: null,
                Method: "Get",
                Action: "TransactionService/GetPystartNotInsertEnteghal?date=" + this.date,
            }
            console.log(axios)
            this.loadingRender = true;
            this.$PostData(axios).then((data) => {
                data = JSON.parse(data)
                if (data.status != 1) {
                    this.$mySweetDefaultTost("", "عملیات با خطا مواجه شد", "error", 2000);
                }

                console.log(data.data.transactions)
                this.response = data.data.transactions
                this.response.forEach(x => {
                    let splitCard= x.card_number.split("******")
                    x.card_number = splitCard[1] + "******" + splitCard[0];
                })

            }).catch(err => {
                this.$mySweetDefaultTost("", "خطا در سرور", "error", 2000);
                this.loadingRender = false;

            }).finally(() => {
                this.loadingRender = false;
            })

        },
        Getreport(server) {

            this.response = [];
            this.loadingRender = true;
            let info;
            let list = [];
            const formData = new FormData();
            formData.append('refNo', this.Iban);
            formData.append('Date', this.TarikhAz);
            formData.append('Server', server);
            this.DataAxiosRow.ArryfildValue = formData;
            this.$PostFormData(this.DataAxiosRow).then((data) => {
                if (data.length > 0) {
                    if (data.length > 10) {
                        this.config.pagination = true;
                    } else {
                        this.config.pagination = false;
                    }
                    for (let index = 0; index < data.length; index++) {
                        info = data[index];
                        list.push(info);
                    }
                    this.loadingRender = false;
                    this.response = this.$FormatMablaghGrid(list);
                    this.exelReport(this.rows);
                } else {
                    this.loadingRender = false;
                    this.$mySweetDefaultTost(
                        "عدم وجود اطلاعات",
                        "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
                        "info",
                        2000
                    );
                    this.config.pagination = false;
                    this.response = [];
                }

            });
        },
        Download() {
            document.getElementById("DownloadExcel").click();
        },
        exelReport() {
            this.exceltable = [];
            this.response.forEach((element) => {
                var excelrow = {
                    "order_id": element.order_id,
                    // "": element.,

                };

                this.exceltable.push(excelrow);
            });
            //     {
            //         label: "شماره سفارش",
            //         name: "order_id",
            //     },
            //     {
            //         label: "تاریخ",
            //         name: "created_at",
            //     },
            //     {
            //         label: "شماره مرجع بانکی",
            //         name: "ref_id",
            //     },
            //     {
            //         label: "مبلغ تراکنش",
            //         name: "payment_amount",
            //     },
            //     {
            //         label: "شماره کارت",
            //         name: "card_number",
            //     },
            //     {
            //         label: "موبایل پرداخت کننده",
            //         name: "payer_phone",
            //     },
        },
    }

}
</script>
<style scoped></style>